import { alpha, createTheme, responsiveFontSizes } from '@mui/material/styles'
import kinTheme from './theme'
import { oraleTaqueroMetalBackground } from './oraleTaqueroStyles'

export const defaultProjectId = 'fantabulousfredd'

export const projectThemes = {
    fantabulousfredd: {
        mode: 'dark',
        background: '#070123',
        surface: '#160B32',
        accent: '#FB8FD8',
        secondary: '#B7A1FF',
        text: '#FFE9F9',
        muted: '#DDBDDD',
        textShadow: '1px 1px 4px #B800B8'
    },
    giftxchange: {
        mode: 'light',
        background: '#24C0A8',
        surface: '#BCF3E8',
        accent: '#084C43',
        secondary: '#9A174B',
        text: '#073D35',
        muted: '#14574C',
        textShadow: 'none'
    },
    santasmailbox: {
        mode: 'light',
        background: '#FFF2DE',
        surface: '#F3DFC2',
        accent: '#8F5130',
        secondary: '#087F79',
        text: '#633E2A',
        muted: '#80543B',
        textShadow: 'none'
    },
    oraletaquero: {
        mode: 'dark',
        background: oraleTaqueroMetalBackground.backgroundColor,
        backgroundImage: oraleTaqueroMetalBackground.backgroundImage,
        surface: '#2C3035',
        accent: '#FFD071',
        secondary: '#8EDCFF',
        text: '#F2F4F5',
        muted: '#CDD3D8',
        textShadow: 'none'
    },
    smartvads: {
        mode: 'dark',
        background: '#0B0C10',
        surface: '#1F2833',
        accent: '#66FCF1',
        secondary: '#A1BAFF',
        text: '#E3FBF8',
        muted: '#B4D2CF',
        textShadow: 'none'
    }
}

export const getProjectVariables = (projectId) => {
    const project = projectThemes[projectId] || projectThemes[defaultProjectId]

    return {
        '--project-background': project.background,
        '--project-background-image': project.backgroundImage || 'none',
        '--project-surface': project.surface,
        '--project-accent': project.accent,
        '--project-text': project.text,
        '--project-text-shadow': project.textShadow,
        '--project-controls-background': alpha(project.surface, 0.92)
    }
}

export const createProjectTheme = (projectId) => {
    const project = projectThemes[projectId] || projectThemes[defaultProjectId]

    return responsiveFontSizes(createTheme({
        ...kinTheme,
        project: {
            id: projectId,
            logoFilter: project.mode === 'light' ? 'brightness(0) saturate(100%)' : 'none'
        },
        palette: {
            ...kinTheme.palette,
            mode: project.mode,
            primary: { main: project.accent },
            secondary: { main: project.secondary },
            background: { default: project.background, paper: project.surface },
            text: { primary: project.text, secondary: project.muted },
            divider: alpha(project.accent, 0.24),
            action: { active: project.accent, hover: alpha(project.accent, 0.1) }
        },
        components: {
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        backgroundColor: project.surface,
                        backgroundImage: 'none',
                        color: project.accent,
                        borderBottom: `1px solid ${alpha(project.accent, 0.24)}`
                    }
                }
            },
            MuiDrawer: {
                styleOverrides: {
                    paper: { backgroundImage: 'none' }
                }
            },
            MuiCssBaseline: {
                styleOverrides: {
                    ':root': getProjectVariables(projectId),
                    'body, .MuiAppBar-root, .MuiDrawer-paper, footer': {
                        transition: 'background-color 240ms ease, color 240ms ease, border-color 240ms ease'
                    },
                    '*': { scrollbarColor: `${project.accent} ${project.surface}` },
                    '*::-webkit-scrollbar, *::-webkit-scrollbar-track': {
                        backgroundColor: project.surface
                    },
                    '*::-webkit-scrollbar-thumb': {
                        backgroundColor: project.accent,
                        borderColor: project.surface
                    },
                    '::selection': { backgroundColor: project.accent, color: project.background },
                    '@media (prefers-reduced-motion: reduce)': {
                        'body, .MuiAppBar-root, .MuiDrawer-paper, footer': { transition: 'none' }
                    }
                }
            }
        }
    }))
}
